import React from "react";
import { useNavigate } from "react-router-dom";
import Resource from "./Resource";
import "./Resource.css";

const ResourceMain: React.FC = () => {
  const navigate = useNavigate();

  const handleCreate = () => {
    navigate("/resources/create");
  };

  const handleEdit = (row: any) => {
    navigate(`/resources/edit/${row.id}`);
  };

  return (
    <div className="resource-main">
      <Resource onCreate={handleCreate} onEdit={handleEdit} />
    </div>
  );
};

export default ResourceMain;
